/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { deepObjectExtend } from '../utils/object';
import { rowSpacing, fontSize, paletteHD } from './variables';

export const combineStyle = (typography, palette, classObjFunc) => {
    const newPalette = !palette || !palette.cta1 ? paletteHD : palette;

    let styles = {};

    if (typeof classObjFunc === 'object') {
        Object.keys(classObjFunc).forEach((item) => {
            const classFunc = classObjFunc[item];
            if (typeof classFunc === 'function') {
                const classObj = classFunc(typography, newPalette);
                Object.keys(classObj).forEach((className) => {
                    if (typeof classObj === 'object') {
                        styles = deepObjectExtend(styles, {
                            [className]: { ...classObj[className] },
                        });
                    }
                });
            }
        });
    }

    return {
        ...styles,
    };
};

export { rowSpacing, fontSize, paletteHD };

export default {
    combineStyle,
    rowSpacing,
    fontSize,
    paletteHD,
};
